import React from "react";
import { connect } from "react-redux";
import ForgotPassword from "../../screens/ForgotPassword/index";

import Actions from "./action";

const ForgotPasswordContainer = (props) => {
  return <ForgotPassword forgotPassword={props.forgotPassword} />;
};

const mapStateToProps = (state) => {
  return {
    ...state.controlReducer,
  };
};

export default connect(mapStateToProps, { ...Actions })(
  ForgotPasswordContainer
);
